module.exports = __webpack_public_path__ + "socicon.2365540442899a584fdf.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/socicon/font/socicon.ttf
// module id = 278
// module chunks = 13